import { render, staticRenderFns } from "./IntroducerForm.vue?vue&type=template&id=68dc1962&"
import script from "./IntroducerForm.vue?vue&type=script&lang=js&"
export * from "./IntroducerForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports